import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FiMonitor, FiSmartphone, FiLayout, FiLock, FiZap, FiCheckCircle } from "react-icons/fi";
import HeroBanner from "../components/HeroBanner";
import SectionWrapper from "../components/SectionWrapper";
import webappHero from "../assets/webapp-hero.jpg";

const features = [
  { icon: FiMonitor, title: "Responsive Business Websites", desc: "Modern, mobile-first websites that look stunning on every device and load lightning fast." },
  { icon: FiSmartphone, title: "Progressive Web Apps (PWA)", desc: "App-like experiences that work offline, send push notifications, and install on any device." },
  { icon: FiLayout, title: "Android & iOS Applications", desc: "Native and cross-platform mobile apps with seamless UX and robust backend integration." },
  { icon: FiLock, title: "Admin Panels & Portals", desc: "Custom dashboards and management portals for internal operations and client-facing services." },
  { icon: FiZap, title: "Performance Optimized", desc: "Core Web Vitals optimized with lazy loading, code splitting, and CDN delivery." },
  { icon: FiCheckCircle, title: "Secure Architecture", desc: "HTTPS, data encryption, secure authentication, and compliance-ready implementations." },
];

const techStack = ["React", "Next.js", "Node.js", "Flutter", "React Native", "TypeScript", "Python", "AWS", "Docker", "MongoDB", "PostgreSQL", "Firebase"];

const WebAppDevelopment = () => {
  return (
    <>
      <HeroBanner
        image={webappHero}
        title="Web & App Development"
        subtitle="Custom-built, performance-optimized websites and applications with modern UI/UX, animations, and secure architecture."
      />

      <SectionWrapper>
        <div className="text-center mb-12">
          <h2 className="section-title mb-4">What We <span className="text-primary">Build</span></h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((f, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }} className="card-hover">
              <f.icon className="w-10 h-10 text-primary mb-4" />
              <h3 className="font-montserrat font-bold text-lg mb-2">{f.title}</h3>
              <p className="text-muted-foreground font-roboto text-sm">{f.desc}</p>
            </motion.div>
          ))}
        </div>
      </SectionWrapper>

      <SectionWrapper className="bg-muted">
        <div className="text-center mb-12">
          <h2 className="section-title mb-4">Our Tech <span className="text-primary">Stack</span></h2>
        </div>
        <div className="flex flex-wrap justify-center gap-4">
          {techStack.map((tech, i) => (
            <motion.span
              key={i}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05 }}
              className="bg-card border border-border px-6 py-3 rounded-full font-montserrat font-semibold text-sm shadow-sm hover:shadow-md hover:border-primary transition-all"
            >
              {tech}
            </motion.span>
          ))}
        </div>
      </SectionWrapper>

      <SectionWrapper className="bg-primary text-primary-foreground text-center">
        <h2 className="text-3xl md:text-4xl font-montserrat font-bold mb-4">Start Your Project Today</h2>
        <Link to="/contact" className="btn-hero-outline">Get a Free Quote</Link>
      </SectionWrapper>
    </>
  );
};

export default WebAppDevelopment;
